import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { GameplayTierBadge } from '#src/components/card/GameplayTierBadge/index.tsx';

import type { NBAGameplayTierBadge_anyPlayerInterface } from './__generated__/index.graphql.ts';

type Props = {
  anyPlayer: NBAGameplayTierBadge_anyPlayerInterface;
  height?: number;
  className?: string;
  progressDotClassName?: string;
  overCap?: boolean;
};

export const NBAGameplayTierBadge = ({
  anyPlayer,
  height,
  className,
  progressDotClassName,
  overCap,
}: Props) => {
  const { gameplayTier, lastTenPlayedSo5AverageScore } = anyPlayer;
  if (!gameplayTier) {
    return null;
  }

  return (
    <GameplayTierBadge
      gameplayTier={gameplayTier}
      l10Score={lastTenPlayedSo5AverageScore}
      height={height}
      className={className}
      progressDotClassName={progressDotClassName}
      overCap={overCap}
    />
  );
};

NBAGameplayTierBadge.fragments = {
  anyPlayerInterface: gql`
    fragment NBAGameplayTierBadge_anyPlayerInterface on AnyPlayerInterface {
      slug
      gameplayTier
      lastTenPlayedSo5AverageScore: averageScore(
        type: LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
      )
    }
  ` as TypedDocumentNode<NBAGameplayTierBadge_anyPlayerInterface>,
};
